"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const useControlEvents_1 = __importDefault(require("../../hooks/useControlEvents"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const LoadingPlaceholder_1 = __importDefault(require("../LoadingPlaceholder"));
const SubTextInputRenderer_1 = __importDefault(require("./SubTextInputRenderer"));
const TextInputRenderer = ({ control, style, }) => {
    const { functions: { processor }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(control);
    (0, useOnLoad_1.default)(control, events);
    // If muiltiline is enabled, keep blurOnSubmit false. otherwise it will
    // not inssert a new line
    let blurOnSubmit;
    if (Boolean(control.blurOnSubmit) === false) {
        if (Boolean(control.multiline) === true) {
            blurOnSubmit = false;
        }
        else {
            blurOnSubmit = true;
        }
    }
    else {
        blurOnSubmit = false;
    }
    const onChangeText = (0, react_1.useCallback)((newValue) => {
        if (events.onChange && !control.inputMask && !control.placesAutocomplete) {
            events.onChange(newValue);
        }
        if (processor) {
            processor.root.updateControlById({
                control,
                dataToUpdate: {
                    value: newValue,
                },
            });
        }
    }, [processor, control, events]);
    const onMaskMatched = (0, react_1.useCallback)((...eventProps) => {
        if (control.inputMask && events.onMaskMatched) {
            events.onMaskMatched(eventProps);
        }
    }, [events, control.inputMask]);
    return (react_1.default.createElement(LoadingPlaceholder_1.default, { control: control, style: style },
        react_1.default.createElement(SubTextInputRenderer_1.default, { control: control, style: style, onChangeText: onChangeText, blurOnSubmit: blurOnSubmit, onSubmitEditing: events.onSubmitEditing, onBlur: events.onBlur, onFocus: events.onFocus, onChange: events.onChange, onMaskMatched: onMaskMatched, onChangeAddress: (newAdress) => {
                if (events.onChange) {
                    events.onChange(newAdress);
                }
                processor.root.updateControlById({
                    control,
                    dataToUpdate: {
                        value: newAdress,
                    },
                });
            } })));
};
exports.default = TextInputRenderer;
